// extracted by mini-css-extract-plugin
export default {"header":"_36VuzQ3I","heading":"_3KCAH-mh","sourceLine":"d7gTKUyn","bestMatchLink":"_12IcH_a_"};